/**
 * ClickHouse daemon installation options
 */
export interface DaemonInstallOptions {
  /**
   * Directory where ClickHouse binary and data will be stored
   * @default "~/.clickhouse"
   */
  installDir?: string
}

/**
 * ClickHouse daemon startup options
 */
export interface DaemonServerOptions {
  /** Path to ClickHouse binary */
  binaryPath: string
  /** Directory where server data will be stored */
  dataDir: string
  /** HTTP port for ClickHouse server @default 8123 */
  httpPort?: number
  /** Directory where server logs will be stored */
  logDir: string
  /** Native TCP port for ClickHouse server @default 9000 */
  tcpPort?: number
}

/**
 * Options for waiting for server readiness
 */
export interface WaitForReadyOptions {
  /** Interval between checks in milliseconds @default 500 */
  interval?: number
  /** HTTP port to check @default 8123 */
  port?: number
  /** Maximum time to wait in milliseconds @default 30000 */
  timeout?: number
}

/**
 * Result of server status check
 */
export interface ServerStatusResult {
  /** Whether the server is running */
  isRunning: boolean
  /** Port the server is running on (if running) */
  port?: number
}

/**
 * Configuration options for daemon client connection
 */
export interface DaemonClientOptions {
  /** ClickHouse database name @default "default" */
  database?: string
  /** Directory where ClickHouse binary and data will be stored @default "~/.clickhouse" */
  installDir?: string
  /** Password for ClickHouse authentication */
  password?: string
  /** HTTP port for ClickHouse server @default 8123 */
  port?: number
  /** Custom ClickHouse server URL (overrides port) */
  url?: string
  /** Username for ClickHouse authentication */
  username?: string
}
